export default __webpack_public_path__ + "static/media/Group785.29ce87ec.svg";